/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetMeProfileResponseData,
  GetMeProfileResponseDataFromJSON,
  GetMeProfileResponseDataFromJSONTyped,
  GetMeProfileResponseDataToJSON
} from './GetMeProfileResponseData'

/**
 *
 * @export
 * @interface GetMeProfileResponse
 */
export interface GetMeProfileResponse {
  /**
   *
   * @type {number}
   * @memberof GetMeProfileResponse
   */
  status?: number
  /**
   *
   * @type {GetMeProfileResponseData}
   * @memberof GetMeProfileResponse
   */
  data?: GetMeProfileResponseData
}

export function GetMeProfileResponseFromJSON(json: any): GetMeProfileResponse {
  return GetMeProfileResponseFromJSONTyped(json, false)
}

export function GetMeProfileResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMeProfileResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetMeProfileResponseDataFromJSON(json['data'])
  }
}

export function GetMeProfileResponseToJSON(value?: GetMeProfileResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetMeProfileResponseDataToJSON(value.data)
  }
}
